import axios from 'axios';
import index from './index';
export default {
  /**
   *
   * @returns
   */
  getData() {
    return axios.get(`/modules/${index.api}/`);
  },

  async fetchPerlschnur(fileNameSlashChecksum){
    return axios.get(this.getFetchPerlschnurUrl(fileNameSlashChecksum))
  },

  getFetchPerlschnurUrl(fileNameSlashChecksum){
    return `/modules/fahrdienst452/perlschnur/${fileNameSlashChecksum}`
  },

  fetchUrl(url){
    return axios.get(url)
  }
};
